import { useEffect } from 'react';
import { useUserState } from '../context/UserContext/UserContext';

const GenesysWrapper = ({ children }) => {
  const userState = useUserState();

  useEffect(() => {
    if (!window.Genesys) {
      console.error('Genesys is not available');
      return;
    }

    const handler = () => {
      if (!userState?.amisId) return;

      const payload = {
        messaging: {
          customAttributes: {
            ID: userState.amisId,
            Name: `${userState.firstName ?? ''} ${userState.lastName ?? ''}`.trim(),
            Phone: userState.phoneNumber,
          },
        },
      };

      console.log('Sending Genesys attributes', payload);
      window.Genesys('command', 'Database.set', payload);
    };

    window.Genesys('subscribe', 'Messenger.opened', handler);

    return () => {
      window.Genesys('unsubscribe', 'Messenger.opened', handler);
    };
  }, [
    userState?.amisId,
    userState?.firstName,
    userState?.lastName,
    userState?.phoneNumber,
  ]);

  return children;
};

export default GenesysWrapper;
